import { ListPageLayout } from "@/components/list-page-layout";
import { usePageTitle } from "@/hooks/use-page-title";
import { ChannelsDataTable } from "./channels-data-table";

export default function ChannelListView() {
  usePageTitle("Channel List");

  return (
    <ListPageLayout
      pageType="channels::list"
      title="Channel List"
      ariaLabel="Channel List"
      headingId="channel-list-heading"
    >
      <ChannelsDataTable />
    </ListPageLayout>
  );
}
